import React from "react";
import './style.less';
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';

export default class TrainingBanner extends React.Component{

    render() {
        return (
            <div className={'training-banner'}>
                <h1>
                    <Texty>
                        培训
                    </Texty>
                </h1>
                <p>
                    <Texty>
                        面向客户提供的专业培训是力动几何重要的服务环节
                    </Texty>
                </p>
            </div>
        )
    }
}
